import { IntlShape } from 'react-intl';

import { SubtitleConfig } from '@/scenarios/legacy-player/components/Player';

export const getTextTrackOption = (
    intl: IntlShape,
    { languageName, studio, type, forAdult }: SubtitleConfig
) => {
    const forAdultMessage = intl.formatMessage(
        {
            id: 'components.PlayerSkin.928ea96017c1abceca082a298cf9978b',
            defaultMessage:
                '{languageName}{studio, select, undefined {} other { · }}{studio}{forAdult, select, true { · 18+} other {}}',
            description: 'Название дорожки субтитров в формате Язык  · Студия ·  18+',
        },
        {
            languageName,
            studio,
            forAdult,
        }
    );

    return {
        name: forAdultMessage,
        note: type,
        q: true,
    };
};
